import React from 'react';
import WizardTextInputComponent from 'components/v2/epd-wizard-inputs/WizardTextInput';
import { useDocumentStore } from '../hooks/useDocumentStore';

const PublicationMetadataRenderer: React.FC = () => {
  const {
    metadata: { epdOwner },
  } = useDocumentStore();

  return (
    <>
      <WizardTextInputComponent label="EPD Owner" name="companyName" value={epdOwner?.companyName} disabled />
      <WizardTextInputComponent label="Contact e-mail" name="contactEmail" value={epdOwner?.contactEmail} disabled />
      <WizardTextInputComponent label="Contact person name" name="contactPerson" value={epdOwner?.contactName} disabled />
      <WizardTextInputComponent label="Country" name="country" value={epdOwner?.companyCountry} disabled />
      <WizardTextInputComponent label="Copyright" name="copyright" value={'Yes'} disabled />
      <WizardTextInputComponent
        label="License type"
        name="licenseType"
        value={'Free of charge for all users and uses'}
        disabled
      />
    </>
  );
};

export default PublicationMetadataRenderer;
